export default __webpack_public_path__ + "static/media/sql.a5b4315a.png";